import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { deleteOfferApply, getOfferApply } from "services/offer_apply_service";
import { Link } from "react-router-dom";

import { useParams } from "react-router";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";

import { useForm, Controller } from "react-hook-form";
import config from "config.json";
import { getAccount } from "services/account_service";

import {
  updateOffer,
  applyOffer,
  getOfferApplyByAccount,
} from "services/offer_service";

function App() {
  const { register, handleSubmit, setValue, control } = useForm({});
  const navigate = useNavigate();

  const [offerTypeID, setOfferTypeID] = useState(null);
  const [offerRole, setOfferRole] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [readonly, setReadOnly] = useState(false);
  const [acc, setAcc] = useState(null);
  const [offerApply, setOfferApply] = useState({});
  const { offerId, candidateId } = useParams();

  useEffect(() => {
    async function fetchData() {
      let offerApplyList = await getOfferApplyByAccount(
        offerId,
        localStorage.getItem("accountId")
      );

      if (localStorage.getItem("role") !== "Clube") {
        setOfferRole(localStorage.getItem("role"));
      }

      let offerApply = [];

      if (candidateId) {
        offerApply = await getOfferApply(candidateId);
      }

      if (offerApply.length === 0 && offerApplyList.length === 0) {
        console.log(`Offer apply not found with the id: ${candidateId}}`);
        return;
      }

      let offer = offerApplyList.length > 0 ? offerApplyList[0] : offerApply;

      const acct = await getAccount(offer.attributes.account.data.id);
      console.log("🚀 ~ useEffect ~ acct:", acct);

      setReadOnly(true);
      setOfferRole(offer.attributes.job_offer.data.attributes.role);
      setOfferTypeID(offer.id);
      setValue("description", offer.attributes.description);
      setValue("team", offer.attributes.team);
      setValue("position", offer.attributes.position);
      setValue("level", offer.attributes.level);
      setOfferApply(offer);
      setAcc(acct);
    }

    fetchData();
  }, []);

  const submitApplyForm = async (data) => {
    data = {
      ...data,
      job_offer: +offerId,
      account: +localStorage.getItem("accountId"),
    };

    if (offerTypeID) {
      await updateOffer(data, offerTypeID);
    } else {
      await applyOffer(data);
    }

    navigate(`/ofertas`);
  };

  return (
    <>
      <h1 className="title is-3">A minha candidatura</h1>
      <form onSubmit={handleSubmit((data) => submitApplyForm(data))}>
        <div className="block">
          <div className="field">
            <label className="label">Nome</label>
            {candidateId && (
              <Link to={`/conta/${offerApply?.attributes?.account?.data?.id}`}>
                <p className="control">
                  {offerApply?.attributes?.account?.data?.attributes?.name}
                </p>
              </Link>
            )}
            {!candidateId && (
              <p className="control">{localStorage.getItem("accountName")}</p>
            )}
          </div>
        </div>
        <div className="block">
          <div className="field">
            <label className="label">Idade</label>
            <p className="control">
              {candidateId &&
              offerApply?.attributes?.account?.data?.attributes?.date_of_birth
                ? moment().diff(
                    offerApply?.attributes?.account?.data?.attributes
                      ?.date_of_birth,
                    "years"
                  )
                : moment().diff(localStorage.getItem("date_of_birth"), "years")}
            </p>
          </div>
        </div>
        <div className="block">
          <div className="field">
            <label className="label">Email</label>
            <p className="control">
              {candidateId
                ? acc?.attributes?.users?.data[0].attributes?.username
                : localStorage.getItem("username")}
            </p>
          </div>
        </div>
        <div className="block">
          <div className="field">
            <label className="label">Telefone</label>
            <p className="control">
              {candidateId
                ? offerApply?.attributes?.account?.data?.attributes
                    ?.phone_number
                : localStorage.getItem("phone_number")}
            </p>
          </div>
        </div>
        <div className="block">
          <div className="field">
            <label className="label">Clube Atual</label>
            <p className="control">
              <input
                className="input"
                type="text"
                disabled={readonly}
                {...register("team", {
                  required: false,
                })}
              ></input>
            </p>
          </div>
        </div>

        {offerRole === "Jogador" && (
          <div>
            <div className="block">
              <div className="field">
                <label className="label">Plantel</label>
                <div className="select is-info">
                  <select
                    disabled={readonly}
                    {...register("level", {
                      required: true,
                    })}
                  >
                    <option value={null}></option>
                    {config.COMPETITIONS_LEVEL.map((el, idx) => (
                      <option key={idx} value={el}>
                        {el}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <div className="block">
              <div className="field">
                <label className="label">Posição equipa atual:</label>
                <Controller
                  name="position"
                  // disabled={isDisabled()}
                  control={control}
                  isDisabled={readonly}
                  render={({ field: { onChange, value } }) => (
                    <Select
                      isDisabled={readonly}
                      options={config.POSITIONS_PLAYER}
                      // isDisabled={isDisabled()}
                      onChange={(val) => {
                        onChange(val.value);
                        setRefresh(!refresh); // necessary to refresh the component
                      }}
                      value={config.POSITIONS_PLAYER.find(
                        (c) => c.value === value
                      )}
                    />
                  )}
                />
              </div>
            </div>
          </div>
        )}

        {offerRole === "Outros" && (
          <div className="block">
            <div className="field">
              <label className="label">Função Atual</label>
              <Controller
                name="sub_role"
                control={control}
                disabled={readonly}
                render={({ field: { onChange, value } }) => (
                  <Select
                    options={config.POSITIONS_PLAYER}
                    // isDisabled={isDisabled()}
                    onChange={(val) => {
                      onChange(val.value);
                    }}
                    value={config.POSITIONS_PLAYER.find(
                      (c) => c.value === value
                    )}
                  />
                )}
              />
            </div>
          </div>
        )}

        <br />

        <div className="block">
          <div className="field">
            <label className="label">Notas Adicionais</label>
            <p className="control">
              <textarea
                className="textarea"
                type="text"
                rows="7"
                disabled={readonly}
                {...register("description", {
                  required: true,
                  minLength: 5,
                  maxLength: 300,
                })}
                placeholder={
                  "Adicione informações relevantes para a sua candidatura."
                }
              ></textarea>
            </p>
          </div>
        </div>
        {!readonly && <button className="button">Guardar</button>}
      </form>
      {readonly && (
        <button onClick={() => setReadOnly(false)} className="button">
          Alterar Candidatura
        </button>
      )}
      &nbsp;&nbsp;&nbsp;&nbsp;
      {readonly && (
        <button
          onClick={async () => {
            await deleteOfferApply(offerTypeID);
            navigate(`/ofertas`);
          }}
          className="button"
        >
          Apagar Candidatura
        </button>
      )}
    </>
  );
}

export default App;
